<script>
const PARTNER_CATEGORY_OPTIONS = [
  { label: '출고 예정', value: 'outbound' },
  { label: '입고 예정', value: 'inbound' },
  { label: '프로모션', value: 'promotion' },
  { label: '재고 준비', value: 'stock' },
  { label: '응대 불가', value: 'offline' },
  { label: '기타', value: 'etc' }
]

const AONE_CATEGORY_OPTIONS = [
  { label: '회의', value: 'meeting' },
  { label: '현장 작업', value: 'fieldwork' },
  { label: '마감', value: 'closing' },
  { label: '방문 일정', value: 'visit' },
  { label: '휴가/부재', value: 'leave' },
  { label: '교육', value: 'training' },
  { label: '기타', value: 'etc' }
]

export default {
  name: 'ModalScheduleRegistrationForm',
  props: {
    selected: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: 'add'
    }
  },
  emits: ['close-modal', 'reload-schedule'],
  data () {
    return {
      title: '',
      description: '',
      scheduleScope: 'partner',
      scheduleCategory: '',
      startDate: '',
      endDate: '',
      visibility: 'shared',
      status: 'planned',
      partnerId: '',
      isSubmitting: false
    }
  },
  computed: {
    session () {
      return this.$store.getters.getLocalSession || {}
    },
    authLevel () {
      return Number(this.session.authLevel || 0)
    },
    isAdmin () {
      return this.authLevel >= 90
    },
    isPartner () {
      return this.authLevel === 80
    },
    isViewMode () {
      return this.mode === 'view'
    },
    canEdit () {
      return this.mode === 'add' || this.mode === 'modify'
    },
    dialogTitle () {
      if (this.mode === 'add') return '일정 등록'
      if (this.mode === 'modify') return '일정 수정'
      return '일정 상세'
    },
    scopeOptions () {
      if (this.isPartner) {
        return [{ label: '파트너 일정', value: 'partner' }]
      }
      return [
        { label: '파트너 일정', value: 'partner' },
        { label: 'AONE 내부 일정', value: 'aone' }
      ]
    },
    categoryOptions () {
      return this.scheduleScope === 'aone' ? AONE_CATEGORY_OPTIONS : PARTNER_CATEGORY_OPTIONS
    },
    visibilityOptions () {
      return [
        { label: '개인 일정', value: 'private' },
        { label: '내부 공유', value: 'shared' }
      ]
    },
    statusOptions () {
      return [
        { label: '예정', value: 'planned' },
        { label: '진행 중', value: 'in_progress' },
        { label: '완료', value: 'done' },
        { label: '보류', value: 'on_hold' }
      ]
    },
    partnerOptions () {
      return this.$store.getters.getPartnerList || []
    },
    canSelectPartner () {
      return this.isAdmin && this.scheduleScope === 'partner'
    },
    isAoneSchedule () {
      return this.scheduleScope === 'aone'
    },
    scopeLabel () {
      return this.scopeOptions.find((item) => item.value === this.scheduleScope)?.label || '-'
    },
    categoryLabel () {
      return this.categoryOptions.find((item) => item.value === this.scheduleCategory)?.label || '-'
    },
    statusLabel () {
      return this.statusOptions.find((item) => item.value === this.status)?.label || '-'
    },
    visibilityLabel () {
      return this.visibilityOptions.find((item) => item.value === this.visibility)?.label || '-'
    },
    partnerLabel () {
      return this.partnerOptions.find((item) => Number(item.value) === Number(this.partnerId))?.label || '-'
    }
  },
  watch: {
    selected: {
      handler () {
        this.hydrateSelected()
      },
      deep: true,
      immediate: true
    },
    scheduleScope () {
      if (this.scheduleScope === 'aone') {
        this.partnerId = ''
        this.visibility = this.visibility || 'shared'
      } else if (this.isPartner) {
        this.partnerId = this.session.partnerId || ''
      }

      if (!this.categoryOptions.find((item) => item.value === this.scheduleCategory)) {
        this.scheduleCategory = ''
      }
    }
  },
  methods: {
    normalizeDate (value) {
      return String(value || '').replaceAll('-', '/')
    },
    denormalizeDate (value) {
      return String(value || '').replaceAll('/', '-')
    },
    hydrateSelected () {
      const selected = this.selected || {}
      this.title = selected.title || ''
      this.description = selected.details || ''
      this.scheduleScope = selected.scheduleScope || (this.isPartner ? 'partner' : 'partner')
      this.scheduleCategory = selected.scheduleCategory || ''
      this.startDate = this.normalizeDate(selected.startDate || selected.date || '')
      this.endDate = this.normalizeDate(selected.endDate || selected.date || '')
      this.visibility = selected.visibility || 'shared'
      this.status = selected.status || 'planned'
      this.partnerId = selected.partnerId || this.session.partnerId || ''
    },
    calculateDays (startDate, endDate) {
      const start = new Date(startDate)
      const end = new Date(endDate)
      if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return 0
      const diff = Math.floor((end.getTime() - start.getTime()) / 86400000)
      return diff >= 0 ? diff + 1 : 0
    },
    validateForm () {
      if (!this.scheduleScope) return '일정 구분을 선택해 주세요.'
      if (!this.scheduleCategory) return '일정 유형을 선택해 주세요.'
      if (!this.title.trim()) return '제목을 입력해 주세요.'
      if (!this.startDate) return '시작일을 선택해 주세요.'
      if (!this.endDate) return '종료일을 선택해 주세요.'
      if (this.scheduleScope === 'partner' && !this.partnerId) return '파트너를 선택해 주세요.'
      const days = this.calculateDays(this.startDate, this.endDate)
      if (days <= 0) return '종료일은 시작일보다 빠를 수 없습니다.'
      return null
    },
    buildPayload () {
      return {
        id: this.selected?.id,
        scheduleScope: this.scheduleScope,
        scheduleCategory: this.scheduleCategory,
        title: this.title.trim(),
        description: this.description.trim(),
        startDate: this.denormalizeDate(this.startDate),
        endDate: this.denormalizeDate(this.endDate),
        visibility: this.scheduleScope === 'aone' ? this.visibility : 'shared',
        status: this.status,
        partnerId: this.scheduleScope === 'partner' ? this.partnerId : null
      }
    },
    async controlUnit () {
      const validationMessage = this.validateForm()
      if (validationMessage) {
        this.$q.notify({ type: 'negative', message: validationMessage, position: 'top', timeout: 3000 })
        return
      }

      const modeTxt = this.mode === 'add' ? '등록' : '수정'
      const config = {
        method: 'POST',
        url: this.mode === 'add' ? '/api/schedule/reg' : '/api/schedule/modify',
        data: this.buildPayload(),
        name: `[ Axios / 스케쥴 ${modeTxt} ]`
      }

      this.isSubmitting = true
      await this.$http(config)
        .then(() => {
          this.$emit('reload-schedule')
          this.$emit('close-modal')
          this.$q.notify({ type: 'positive', message: `일정을 ${modeTxt}했습니다.`, position: 'top', timeout: 2500 })
        })
        .catch((err) => {
          this.$log.debug(err)
          this.$q.notify({
            type: 'negative',
            message: err.response?.data?.message || `일정 ${modeTxt}에 실패했습니다.`,
            position: 'top',
            timeout: 3000
          })
        })
        .finally(() => {
          this.isSubmitting = false
        })
    },
    async deleteUnit () {
      this.$q.dialog({
        title: '일정을 삭제하시겠습니까?',
        message: '삭제 후 복구할 수 없습니다.',
        cancel: true,
        persistent: true
      }).onOk(async () => {
        const config = {
          method: 'POST',
          url: '/api/schedule/delete',
          data: { id: this.selected.id },
          name: '[ Axios / 스케쥴 삭제 ]'
        }

        this.isSubmitting = true
        await this.$http(config)
          .then(() => {
            this.$emit('reload-schedule')
            this.$emit('close-modal')
            this.$q.notify({ type: 'positive', message: '일정을 삭제했습니다.', position: 'top', timeout: 2500 })
          })
          .catch((err) => {
            this.$log.debug(err)
            this.$q.notify({
              type: 'negative',
              message: err.response?.data?.message || '일정 삭제에 실패했습니다.',
              position: 'top',
              timeout: 3000
            })
          })
          .finally(() => {
            this.isSubmitting = false
          })
      })
    },
    closeModal () {
      this.$emit('close-modal')
    }
  },
  async mounted () {
    if (this.isAdmin) {
      await this.$getPartnerList()
    }
  }
}
</script>

<template>
  <q-card class="schedule-dialog">
    <q-toolbar class="bg-primary text-white">
      <q-toolbar-title>{{ dialogTitle }}</q-toolbar-title>
      <q-btn flat round dense icon="close" @click="closeModal" />
    </q-toolbar>

    <q-card-section class="dialog-section">
      <div v-if="isViewMode && selected.scheduleScope === 'console'" class="view-notice">
        콘솔에서 자동 반영된 일정입니다. 이 화면에서는 조회만 가능합니다.
      </div>

      <q-select
        v-if="canEdit"
        v-model="scheduleScope"
        outlined
        emit-value
        map-options
        :options="scopeOptions"
        label="일정 구분"
        class="q-mb-md"
      />

      <q-select
        v-if="canEdit"
        v-model="scheduleCategory"
        outlined
        emit-value
        map-options
        :options="categoryOptions"
        label="일정 유형"
        class="q-mb-md"
      />

      <q-select
        v-if="canEdit && canSelectPartner"
        v-model="partnerId"
        outlined
        emit-value
        map-options
        :options="partnerOptions"
        label="파트너"
        class="q-mb-md"
      />

      <q-input
        v-model="title"
        outlined
        label="제목"
        :disable="!canEdit"
        placeholder="달력에 노출되는 일정 제목"
        class="q-mb-md"
      />

      <q-input
        v-model="description"
        outlined
        type="textarea"
        :rows="3"
        label="설명"
        :disable="!canEdit"
        placeholder="일정 설명"
        class="q-mb-md"
      />

      <div class="row q-col-gutter-md q-mb-md">
        <div class="col-12 col-md-6">
          <q-select
            v-model="status"
            outlined
            emit-value
            map-options
            :options="statusOptions"
            :disable="!canEdit"
            label="일정 상태"
          />
        </div>
        <div class="col-12 col-md-6" v-if="canEdit && isAoneSchedule">
          <q-select
            v-model="visibility"
            outlined
            emit-value
            map-options
            :options="visibilityOptions"
            :disable="!canEdit"
            label="공개 범위"
          />
        </div>
      </div>

      <div class="row q-col-gutter-md">
        <div class="col-12 col-md-6">
          <q-input v-model="startDate" outlined label="시작일" readonly :disable="!canEdit">
            <template #append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-date v-model="startDate" mask="YYYY/MM/DD" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>

        <div class="col-12 col-md-6">
          <q-input v-model="endDate" outlined label="종료일" readonly :disable="!canEdit">
            <template #append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-date v-model="endDate" mask="YYYY/MM/DD" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
      </div>

      <div v-if="isViewMode" class="view-meta q-mt-md">
        <div>일정 구분: {{ selected.scheduleScope === 'console' ? '자동 운송 일정' : scopeLabel }}</div>
        <div>일정 유형: {{ selected.scheduleScope === 'console' ? (selected.transportTypeLabel || '-') : categoryLabel }}</div>
        <div v-if="selected.scheduleScope === 'partner'">파트너: {{ selected.partnerName || partnerLabel || '-' }}</div>
        <div v-if="selected.scheduleScope === 'aone'">공개 범위: {{ visibilityLabel }}</div>
        <div v-if="selected.scheduleScope !== 'console'">상태: {{ statusLabel }}</div>
        <div v-if="selected.scheduleScope !== 'console'">작성자: {{ selected.ownerName || '-' }}</div>
      </div>
    </q-card-section>

    <q-card-actions align="between" class="dialog-actions">
      <q-btn
        v-if="mode === 'modify'"
        flat
        color="negative"
        label="삭제"
        :disable="isSubmitting"
        @click="deleteUnit"
      />

      <div class="action-spacer" />

      <q-btn flat label="닫기" :disable="isSubmitting" @click="closeModal" />
      <q-btn
        v-if="canEdit"
        color="primary"
        :label="mode === 'add' ? '등록' : '수정'"
        :loading="isSubmitting"
        :disable="isSubmitting"
        @click="controlUnit"
      />
    </q-card-actions>
  </q-card>
</template>

<style scoped>
.schedule-dialog {
  width: min(720px, 92vw);
  max-width: 92vw;
  border-radius: 18px;
}

.dialog-section {
  padding: 20px;
}

.view-notice {
  margin-bottom: 16px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #eef5ff;
  color: #31557d;
  font-size: 13px;
}

.view-meta {
  display: grid;
  gap: 6px;
  margin-top: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #f7f9fc;
  color: #4b6075;
  font-size: 13px;
}

.dialog-actions {
  padding: 12px 20px 20px;
}

.action-spacer {
  flex: 1 1 auto;
}
</style>
